/*
 * SonarQube
 * Copyright (C) 2009-2025 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import styled from '@emotion/styled';
import { deburr } from 'lodash';
import { createContext, useContext } from 'react';
import Highlighter from 'react-highlight-words';

export const SearchHighlighterContext = createContext<string | undefined>(undefined);
SearchHighlighterContext.displayName = 'SearchHighlighterContext';

interface Props {
  children?: string;
  term?: string;
}

export default function SearchHighlighter({ children = '', term }: Readonly<Props>) {
  const query = useContext(SearchHighlighterContext);
  const searchTerm = term ?? query;
  if (searchTerm) {
    return (
      <StyledHighlighter
        autoEscape
        sanitize={deburr}
        searchWords={[searchTerm]}
        textToHighlight={children}
      />
    );
  }
  return <>{children}</>;
}

const StyledHighlighter = styled(Highlighter)`
  mark {
    font-weight: inherit;
    background-color: var(--echoes-color-tangerine-50);
    color: var(--echoes-color-grey-500);
  }
`;
